import React from 'react';

import { StepRow } from '../../../design/components';
import { getStopStepStatus } from '../stepStatus';

const STEP_DONE_TEXT = {
	pick: 'Picked',
	restock: 'Complete',
	'confirm_values': 'Confirmed',
	'confirm_stock': 'Confirmed',
	tickets: 'Resolved',
	photos: 'Taken',
};

const STEP_PENDING_SYNC_KEYS = {
	restock: 'manualRestock',
	'confirm_stock': 'confirmStockLevels',
	'confirm_values': 'confirmMachineValues',
	photos: 'createMedia',
};

/**
 * StopStepRow: one step in the stop screen's "This stop" list.
 * Props: step, nextStepId, pendingSyncKeys and failedSyncKeys (Sets of this
 * stop's offline queue config keys), needsExpiryCheck, isRepair, onPress(step)
 */
const StopStepRow = ({ step, nextStepId, pendingSyncKeys, failedSyncKeys, needsExpiryCheck, isRepair, onPress }) => {
	const status = getStopStepStatus(step, nextStepId);
	const syncKey = STEP_PENDING_SYNC_KEYS[step.id];
	let statusText;
	let statusTone;
	if (failedSyncKeys.has(syncKey)) {
		statusText = 'Not synced';
		statusTone = 'warning';
	}
	else if (pendingSyncKeys.has(syncKey)) {
		statusText = 'Saved on phone';
		statusTone = 'warning';
	}
	else if (step.done) {
		statusText = STEP_DONE_TEXT[step.id];
	}
	else if (step.isWaiting) {
		statusText = 'Waiting';
		statusTone = 'warning';
	}
	const productsNeedChecking = isRepair && step.id === 'confirm_stock' && needsExpiryCheck && !step.done;
	const expiryTags = !isRepair && step.id === 'confirm_stock' && needsExpiryCheck
		? [{ label: 'Expiry dates require updates', tone: 'warning' }]
		: undefined;
	const isPhotoRequired = step.id === 'photos' && !step.done;

	return (
		<StepRow
			status={status}
			title={step.label}
			subtitle={productsNeedChecking ? 'Products need checking' : isPhotoRequired ? 'At least 1 photo required' : step.description}
			subtitleTone={productsNeedChecking || isPhotoRequired ? 'warning' : 'default'}
			statusText={statusText}
			statusTone={statusTone}
			tags={step.required === false && !step.done ? [{ label: 'Optional' }] : expiryTags}
			onPress={() => onPress(step)}
		/>
	);
};

export default StopStepRow;
